import { Box, HStack, Text, VStack } from '@chakra-ui/react';
import type { IconType } from 'react-icons';

export interface DrawerMenuItem {
  value: string;
  label: string;
  icon?: IconType;
}

interface DrawerSideMenuProps {
  activeItem: string;
  onItemChange: (value: string) => void;
  items: DrawerMenuItem[];
}

export function DrawerSideMenu({
  activeItem,
  onItemChange,
  items,
}: DrawerSideMenuProps) {
  return (
    <VStack align="stretch" gap={1} pt={2} role="navigation" aria-label="Drawer navigation">
      {items.map((item) => {
        const isActive = activeItem === item.value;
        return (
          <Box
            key={item.value}
            px={3}
            py={2}
            borderRadius="md"
            bg={isActive ? 'bg.subtle' : 'transparent'}
            cursor="pointer"
            role="button"
            tabIndex={0}
            aria-label={item.label}
            aria-current={isActive ? 'true' : undefined}
            onClick={() => onItemChange(item.value)}
            onKeyDown={(e: React.KeyboardEvent) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onItemChange(item.value);
              }
            }}
            _hover={{ bg: isActive ? undefined : 'bg.muted' }}
          >
            <HStack gap={2}>
              {item.icon && <item.icon size={16} />}
              <Text
                fontSize="sm"
                fontWeight={isActive ? '600' : '400'}
              >
                {item.label}
              </Text>
            </HStack>
          </Box>
        );
      })}
    </VStack>
  );
}
